export const initialState = {
    leave_type_id: null,
    leave_days: "",
    unuse_leave: "",
    cf_limit: "",
    for_emp: ""
};
